module.exports = __webpack_public_path__ + "static/fg-ba113b5df28981d2c3c07ea28c3ac393.png";